export default __webpack_public_path__ + "media/images/map/car/32x32-27817e0d35f560b082897a569af807ba.png";